import { flatten } from 'ramda';
import React, { memo } from 'react';

import styles from './AlbumsLayout.css';

export interface AlbumsLayoutProps {
    children: any;
}

export const AlbumsLayout = memo(function AlbumsLayout({ children }: AlbumsLayoutProps) {
    const albums = flatten(children);

    return <div className={styles.root}>{albums}</div>;
});
